// extracted by mini-css-extract-plugin
export var content = "worldCupLocator-module--content--49125";
export var contentContainer = "worldCupLocator-module--content-container--f8865";
export var dropdownLabel = "worldCupLocator-module--dropdown-label--04c61";
export var goldButton = "worldCupLocator-module--gold-button--79b01";
export var mapContainer = "worldCupLocator-module--map-container--a6bfa";
export var offsetBorder = "worldCupLocator-module--offset-border--38314";
export var overlay = "worldCupLocator-module--overlay--83f28";
export var venueDropdown = "worldCupLocator-module--venue-dropdown--920a1";
export var worldCupLocatorSlice = "worldCupLocator-module--world-cup-locator-slice--6b082";